<template>
  <div class="auth">
    <component-layout
      :type="this.type"
      v-on:toggle-type="toggle"
    ></component-layout>
  </div>
</template>

<script>
// import componentLayout from './../components/auth/Layout.vue'
import componentLayout from './../components/auth2/Layout.vue'

export default {
  name: 'auth',

  components: {
    componentLayout
  },

  beforeCreate() {
    // Handle OAuth callbacks that arrive without hash or with hash at the end (LinkedIn)
    // LinkedIn redirects to /?code=XXX#/ but Vue router needs /#/?code=XXX
    const search = window.location.search
    const hash = window.location.hash
    const hasCode = search.includes('code=')

    // Check if code is in search params but not properly in hash router format
    if (hasCode && (hash === '' || hash === '#/' || !hash.includes('?'))) {
      // OAuth callback - need to move search params into hash router
      window.location.href = `${window.location.origin}/#/${search}`
      return
    }

    if (localStorage.user) {
      this.$router.push({
        name: 'dash'
      })
    } else document.body.classList.remove('dash')
  },

  mounted() {
    let scriptCMP1 = document.createElement('script')
    scriptCMP1.setAttribute(
      'src',
      'https://cache.consentframework.com/js/pa/21964/c/lIACl/stub'
    )
    document.head.appendChild(scriptCMP1)

    let scriptCMP2 = document.createElement('script')
    scriptCMP2.setAttribute(
      'src',
      'https://choices.consentframework.com/js/pa/21964/c/lIACl/cmp'
    )
    scriptCMP2.setAttribute('async', 'true')
    document.head.appendChild(scriptCMP2)
  },

  data() {
    return {
      type: 'login'
      // type: 'signup'
    }
  },

  methods: {
    /**
     * Change type to display signup or login layout
     */
    toggle(type) {
      this.type = type
    }
  }
}
</script>
